"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVerifiedAddressList = exports.VerifiedAddressList = void 0;
// tslint:disable:jsx-no-multiline-js
var react_1 = __importDefault(require("react"));
var bindings_1 = require("../bindings");
var VerifiedAddressList = function (_a) {
    var _b;
    var children = _a.children;
    var _c = bindings_1.useMyVerifiedAddressesQuery({}), loading = _c.loading, error = _c.error, data = _c.data;
    return (loading ? (react_1.default.createElement("div", { className: "spinner-border" })) : error ? (react_1.default.createElement("div", { className: "text-danger" }, error.message)) : data ? (react_1.default.createElement(react_1.default.Fragment, null, children((_b = data['verifiedAddresses']) !== null && _b !== void 0 ? _b : []))) : (react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.VerifiedAddressList = VerifiedAddressList;
var UserVerifiedAddressList = function (_a) {
    var children = _a.children, uid = _a.uid;
    var _b = bindings_1.useUserVerifiedAddressesQuery({}), loading = _b.loading, error = _b.error, data = _b.data;
    return (loading ? (react_1.default.createElement("div", { className: "spinner-border" })) : error ? (react_1.default.createElement("div", { className: "text-danger" }, error.message)) : data ? (react_1.default.createElement(react_1.default.Fragment, null, children(data['userVerifiedAddresses'] || []))) : (react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.UserVerifiedAddressList = UserVerifiedAddressList;
//# sourceMappingURL=List.js.map